// add Cloudinary video links here

export const videosData = {
  eventCard:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792416974/eventCardVid_1.mov",
  phinestsDarkMode:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792417402/Screen_Recording_2026-10-19_at_2.29.07_PM.mov",
  rippleHomePageString:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792418583/Screen_Recording_2026-10-19_at_2.12.34_PM.mov",
  rippleServicesAnimation:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792419853/RippleHomePageServices.mov",
  creativityFestivalArabicHomePage:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792675597/Screen_Recording_2026-10-21_at_11.57.40_AM.mov",
  creativityFestivalAboutPage:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792675632/Screen_Recording_2026-10-21_at_12.04.38_PM.mov",
  creativityFestivalSpeakersPage:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792675739/Screen_Recording_2026-10-22_at_4.27.47_PM.mov",
  creativityFestivalContactPage:
    "https://res.cloudinary.com/yn1vpqyb/video/upload/v1792675640/Screen_Recording_2026-10-21_at_12.06.48_PM.mov",
};
